(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trgt-founder-section-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__trgtFounderSliderModalVideoInit) return;
    window.__trgtFounderSliderModalVideoInit = true;

    const tryPlayWithSound = (scope) => {
      const video = scope.querySelector('video');
      if (video) {
        try {
          video.muted = false;
          video.volume = 1;
          video.playsInline = true;
          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        } catch (e) {}
        return;
      }

      const iframe = scope.querySelector('iframe[data-video-type]');
      if (!iframe || !iframe.contentWindow) return;
      const type = iframe.dataset.videoType;
      try {
        if (type === 'youtube') {
          iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (type === 'vimeo') {
          iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', '*');
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
        }
      } catch (e) {}
    };

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (!target.closest('.trgt-founder-section-slider')) return;

        const openDialog = target.closest('dialog.trgt-founder-section-slider__dialog[open]');
        if (openDialog) {
          const dialogComponent = openDialog.closest('dialog-component');
          if (!dialogComponent) return;
          if (target.closest('.trgt-founder-section-slider__modal-video')) return;
          if (target.closest('.trgt-founder-section-slider__dialog-close')) return;
          const dc = dialogComponent;
          if (typeof dc.closeDialog === 'function') dc.closeDialog();
          return;
        }

        const trigger = target.closest('.trgt-founder-section-slider__video-trigger');
        if (!trigger) return;
        const dialogComponent = trigger.closest('dialog-component');
        if (!dialogComponent) return;
        const deferred = dialogComponent.querySelector('deferred-media.trgt-founder-section-slider__modal-video, deferred-media');
        if (!deferred) return;
        try {
          if (typeof deferred.loadContent === 'function') deferred.loadContent(false);
          if (typeof deferred.playMedia === 'function') deferred.playMedia();
        } catch (e) {}
        tryPlayWithSound(deferred);
        dialogComponent.addEventListener('dialog:open', () => tryPlayWithSound(deferred), { once: true });
      },
      { capture: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trgt-founder-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Shopify requires section JS blocks to be static (no Liquid interpolation).
    // Use a global, delegated listener so this works for all instances (and section reloads) without duplicates.
    if (window.__trgtFounderModalVideoInit) return;
    window.__trgtFounderModalVideoInit = true;

    /**
     * @param {Element} scope
     */
    const tryPlayWithSound = (scope) => {
      /** @type {HTMLVideoElement | null} */
      const video = scope.querySelector('video');
      if (video) {
        try {
          video.muted = false;
          video.volume = 1;
          // iOS/Safari friendliness (no-op elsewhere)
          video.playsInline = true;
          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {
              // Autoplay-with-sound can be blocked; best-effort fallback to at least start playback.
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        } catch (e) {
          // no-op (best effort)
        }
        return;
      }

      /** @type {HTMLIFrameElement | null} */
      const iframe = scope.querySelector('iframe[data-video-type]');
      if (!iframe || !iframe.contentWindow) return;

      const type = iframe.dataset.videoType;
      try {
        if (type === 'youtube') {
          iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (type === 'vimeo') {
          iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', '*');
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
        }
      } catch (e) {
        // no-op (best effort)
      }
    };

    // Capture so this runs as early as possible in the same click gesture.
    document.addEventListener(
      'click',
      (event) => {
        const target = /** @type {Element | null} */ (event.target instanceof Element ? event.target : null);
        if (!target) return;

        // Only handle clicks inside the Founder section.
        if (!target.closest('.trgt-founder-section')) return;

        // If the founder video modal is open, close it when clicking anywhere except the video itself.
        // (The shared dialog-component "outside click" logic won't trigger here because this dialog
        // typically spans the full viewport.)
        const openDialog = target.closest('dialog.trgt-founder-section__dialog[open]');
        if (openDialog) {
          const dialogComponent = openDialog.closest('dialog-component');
          if (!dialogComponent) return;

          // Allow clicks on the video/iframe and on the explicit close button.
          if (target.closest('.trgt-founder-section__modal-video')) return;
          if (target.closest('.trgt-founder-section__dialog-close')) return;

          /** @type {any} */
          const dc = dialogComponent;
          if (typeof dc.closeDialog === 'function') dc.closeDialog();
          return;
        }

        const trigger = target.closest('.trgt-founder-section__video-trigger');
        if (!trigger) return;

        const dialogComponent = trigger.closest('dialog-component');
        if (!dialogComponent) return;

        /** @type {any} */
        const deferred = dialogComponent.querySelector('deferred-media.trgt-founder-section__modal-video, deferred-media');
        if (!deferred) return;

        // Force the media to load and start within the click gesture (helps autoplay-with-sound policies).
        try {
          if (typeof deferred.loadContent === 'function') deferred.loadContent(false);
          if (typeof deferred.playMedia === 'function') deferred.playMedia();
        } catch (e) {
          // no-op (best effort)
        }

        tryPlayWithSound(deferred);

        // Retry once the modal is actually open (dialog-component opens in rAF).
        const onOpen = () => tryPlayWithSound(deferred);
        dialogComponent.addEventListener('dialog:open', onOpen, { once: true });
      },
      { capture: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trgt-image-with-text-meta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // NOTE: Liquid output is not evaluated inside `{% javascript %}` blocks.
    // Read any needed values from data-attributes instead.
    const ROOT_SELECTOR = '.trgt__image--with-text[data-iwt-accordion-autoprogress="true"]';

    const initRoot = (root) => {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.iwtAccordionInit === 'true') return;
      const enabled = root.dataset.iwtAccordionAutoprogress === 'true';
      if (!enabled) return;
      root.dataset.iwtAccordionInit = 'true';

      const intervalMs = Math.max(1000, parseInt(root.dataset.iwtAccordionIntervalMs || '6000', 10) || 6000);

      const groups = Array.from(root.querySelectorAll('[data-accordion-single-open="true"]')).filter(
        (el) => el instanceof HTMLElement
      );
      if (!groups.length) return;

      /** @type {Array<() => void>} */
      const cleanups = [];

      const setupGroup = (group) => {
        group.style.setProperty('--trgt-iwt-accordion-duration', `${intervalMs}ms`);

        const detailsList = Array.from(group.querySelectorAll('accordion-custom details[data-testid="accordion-details"]')).filter(
          (el) => el instanceof HTMLDetailsElement
        );
        if (detailsList.length <= 1) return;

        let timer = 0;
        let hovered = false;
        let visible = false;
        let started = false;

        const clear = () => {
          if (timer) window.clearTimeout(timer);
          timer = 0;
        };

        const setProgressActive = (activeDetails) => {
          for (const d of detailsList) {
            if (activeDetails && d === activeDetails) d.setAttribute('data-trgt-progress-active', 'true');
            else d.removeAttribute('data-trgt-progress-active');
          }
        };

        const getOpenIndex = () => detailsList.findIndex((d) => d.open);
        const getOpenDetails = () => detailsList.find((d) => d.open) || null;

        const openAt = (index) => {
          const i = ((index % detailsList.length) + detailsList.length) % detailsList.length;
          const details = detailsList[i];
          if (!details) return;

          details.open = true;
          setProgressActive(details);

          // 🔧 Sync timer exactly with progress start
          clear();
          if (!hovered && visible) {
            timer = window.setTimeout(() => {
              openAt(i + 1);
            }, intervalMs);
          }
        };


        const tick = () => {
          clear();
          if (hovered || !visible) return;

          timer = window.setTimeout(() => {
            const currentIndex = getOpenIndex();
            const nextIndex = currentIndex >= 0 ? currentIndex + 1 : 0;
            openAt(nextIndex);
            tick();
          }, intervalMs);
        };

        const onToggle = (event) => {
          const target = event.target;
          if (!(target instanceof HTMLDetailsElement)) return;
          if (!detailsList.includes(target)) return;
          if (!target.open) return;

          // If user manually opens an item, restart progress from that item.
          setProgressActive(target);
          tick();
        };

        const onPointerEnter = () => {
          hovered = true;
          clear();
        };
        const onPointerLeave = () => {
          hovered = false;
          tick();
        };

        group.addEventListener('toggle', onToggle, true);
        group.addEventListener('mouseenter', onPointerEnter);
        group.addEventListener('mouseleave', onPointerLeave);
        group.addEventListener('focusin', onPointerEnter);
        group.addEventListener('focusout', onPointerLeave);

        const io = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            visible = Boolean(entry && entry.isIntersecting);
            if (!visible) {
              clear();
              setProgressActive(null);
              return;
            }

            // Start auto-progress only once the section reaches the viewport.
            if (!started) {
              started = true;
              const currentIndex = getOpenIndex();
              openAt(currentIndex >= 0 ? currentIndex : 0);
            } else {
              // Resume from the currently open item, restarting the progress bar.
              setProgressActive(getOpenDetails());
            }

            tick();
          },
          { threshold: 0.25 }
        );
        io.observe(group);

        cleanups.push(() => {
          clear();
          io.disconnect();
          group.removeEventListener('toggle', onToggle, true);
          group.removeEventListener('mouseenter', onPointerEnter);
          group.removeEventListener('mouseleave', onPointerLeave);
          group.removeEventListener('focusin', onPointerEnter);
          group.removeEventListener('focusout', onPointerLeave);
        });
      };

      groups.forEach(setupGroup);

      // Cleanup for Theme Editor
      const onUnload = (e) => {
        const container = e.target instanceof HTMLElement ? e.target : null;
        if (!container) return;
        if (!container.contains(root)) return;
        cleanups.forEach((fn) => fn());
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    };

    const initAll = () => {
      document.querySelectorAll(ROOT_SELECTOR).forEach((root) => initRoot(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const scope = e.target instanceof HTMLElement ? e.target : document;
      scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => initRoot(root));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trgt-image-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // NOTE: Liquid output is not evaluated inside `{% javascript %}` blocks.
    // Read any needed values from data-attributes instead.
    const ROOT_SELECTOR = '.trgt__image--with-text[data-iwt-accordion-autoprogress="true"]';

    const initRoot = (root) => {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.iwtAccordionInit === 'true') return;
      const enabled = root.dataset.iwtAccordionAutoprogress === 'true';
      if (!enabled) return;
      root.dataset.iwtAccordionInit = 'true';

      const intervalMs = Math.max(1000, parseInt(root.dataset.iwtAccordionIntervalMs || '6000', 10) || 6000);

      const groups = Array.from(root.querySelectorAll('[data-accordion-single-open="true"]')).filter(
        (el) => el instanceof HTMLElement
      );
      if (!groups.length) return;

      /** @type {Array<() => void>} */
      const cleanups = [];

      const setupGroup = (group) => {
        group.style.setProperty('--trgt-iwt-accordion-duration', `${intervalMs}ms`);

        const detailsList = Array.from(group.querySelectorAll('accordion-custom details[data-testid="accordion-details"]')).filter(
          (el) => el instanceof HTMLDetailsElement
        );
        if (detailsList.length <= 1) return;

        let timer = 0;
        let hovered = false;
        let visible = false;
        let started = false;

        const clear = () => {
          if (timer) window.clearTimeout(timer);
          timer = 0;
        };

        const setProgressActive = (activeDetails) => {
          for (const d of detailsList) {
            if (activeDetails && d === activeDetails) d.setAttribute('data-trgt-progress-active', 'true');
            else d.removeAttribute('data-trgt-progress-active');
          }
        };

        const getOpenIndex = () => detailsList.findIndex((d) => d.open);
        const getOpenDetails = () => detailsList.find((d) => d.open) || null;

        const openAt = (index) => {
          const i = ((index % detailsList.length) + detailsList.length) % detailsList.length;
          const details = detailsList[i];
          if (!details) return;

          details.open = true;
          setProgressActive(details);

          // 🔧 Sync timer exactly with progress start
          clear();
          if (!hovered && visible) {
            timer = window.setTimeout(() => {
              openAt(i + 1);
            }, intervalMs);
          }
        };


        const tick = () => {
          clear();
          if (hovered || !visible) return;

          timer = window.setTimeout(() => {
            const currentIndex = getOpenIndex();
            const nextIndex = currentIndex >= 0 ? currentIndex + 1 : 0;
            openAt(nextIndex);
            tick();
          }, intervalMs);
        };

        const onToggle = (event) => {
          const target = event.target;
          if (!(target instanceof HTMLDetailsElement)) return;
          if (!detailsList.includes(target)) return;
          if (!target.open) return;

          // If user manually opens an item, restart progress from that item.
          setProgressActive(target);
          tick();
        };

        const onPointerEnter = () => {
          hovered = true;
          clear();
        };
        const onPointerLeave = () => {
          hovered = false;
          tick();
        };

        group.addEventListener('toggle', onToggle, true);
        group.addEventListener('mouseenter', onPointerEnter);
        group.addEventListener('mouseleave', onPointerLeave);
        group.addEventListener('focusin', onPointerEnter);
        group.addEventListener('focusout', onPointerLeave);

        const io = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            visible = Boolean(entry && entry.isIntersecting);
            if (!visible) {
              clear();
              setProgressActive(null);
              return;
            }

            // Start auto-progress only once the section reaches the viewport.
            if (!started) {
              started = true;
              const currentIndex = getOpenIndex();
              openAt(currentIndex >= 0 ? currentIndex : 0);
            } else {
              // Resume from the currently open item, restarting the progress bar.
              setProgressActive(getOpenDetails());
            }

            tick();
          },
          { threshold: 0.25 }
        );
        io.observe(group);

        cleanups.push(() => {
          clear();
          io.disconnect();
          group.removeEventListener('toggle', onToggle, true);
          group.removeEventListener('mouseenter', onPointerEnter);
          group.removeEventListener('mouseleave', onPointerLeave);
          group.removeEventListener('focusin', onPointerEnter);
          group.removeEventListener('focusout', onPointerLeave);
        });
      };

      groups.forEach(setupGroup);

      // Cleanup for Theme Editor
      const onUnload = (e) => {
        const container = e.target instanceof HTMLElement ? e.target : null;
        if (!container) return;
        if (!container.contains(root)) return;
        cleanups.forEach((fn) => fn());
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    };

    const initAll = () => {
      document.querySelectorAll(ROOT_SELECTOR).forEach((root) => initRoot(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const scope = e.target instanceof HTMLElement ? e.target : document;
      scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => initRoot(root));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trgt-video-with-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__trgtVideoWithContentModalInit) return;
    window.__trgtVideoWithContentModalInit = true;

    const tryPlayWithSound = (scope) => {
      const video = scope.querySelector('video');
      if (video) {
        try {
          video.muted = false;
          video.volume = 1;
          video.playsInline = true;
          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        } catch (e) {}
        return;
      }
      const iframe = scope.querySelector('iframe[data-video-type]');
      if (!iframe || !iframe.contentWindow) return;
      const type = iframe.dataset.videoType;
      try {
        if (type === 'youtube') {
          iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (type === 'vimeo') {
          iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', '*');
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
        }
      } catch (e) {}
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (!target.closest('.trgt-video-with-content')) return;

      const openDialog = target.closest('dialog.trgt-video-with-content__dialog[open]');
      if (openDialog) {
        const dialogComponent = openDialog.closest('dialog-component');
        if (!dialogComponent) return;
        if (target.closest('.trgt-video-with-content__modal-video')) return;
        if (target.closest('.trgt-video-with-content__dialog-close')) return;
        const dc = dialogComponent;
        if (typeof dc.closeDialog === 'function') dc.closeDialog();
        return;
      }

      const trigger = target.closest('.trgt-video-with-content__video-trigger');
      if (!trigger) return;
      const dialogComponent = trigger.closest('dialog-component');
      if (!dialogComponent) return;
      const deferred = dialogComponent.querySelector('deferred-media.trgt-video-with-content__modal-video, deferred-media');
      if (!deferred) return;
      try {
        if (typeof deferred.loadContent === 'function') deferred.loadContent(false);
        if (typeof deferred.playMedia === 'function') deferred.playMedia();
      } catch (e) {}
      tryPlayWithSound(deferred);
      dialogComponent.addEventListener('dialog:open', () => tryPlayWithSound(deferred), { once: true });
    }, { capture: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
